export default __webpack_public_path__ + "media/images/brands/demo/services/service-03-5b891d42804bdcf51ebc01fecb1b6dda.jpg";